import axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import {
  DEFAULT_FETCH_CONFIG,
  getHttpRequestConfig,
} from "@wff/configs/FetchConfig";

export const axiosParams = {
  ...DEFAULT_FETCH_CONFIG,
};

// Create axios instance with default params
const axiosInstance = axios.create(axiosParams);

// Main api function
const api = (axios: AxiosInstance) => {
  return {
    get: <T>(url: string, config: AxiosRequestConfig = axiosParams) =>
      axios.get<T>(url, getHttpRequestConfig({ url, config })),
    delete: <T>(url: string, config: AxiosRequestConfig = {}) =>
      axios.delete<T>(url, getHttpRequestConfig({ url, config })),
    post: <T>(url: string, body: unknown, config: AxiosRequestConfig = {}) =>
      axios.post<T>(url, body, getHttpRequestConfig({ url, config })),
    patch: <T>(url: string, body: unknown, config: AxiosRequestConfig = {}) =>
      axios.patch<T>(url, body, getHttpRequestConfig({ url, config })),
    put: <T>(url: string, body: unknown, config: AxiosRequestConfig = {}) =>
      axios.put<T>(url, body, getHttpRequestConfig({ url, config })),
  };
};

export default api(axiosInstance);
